import Page from "../Page";
import BackButton from "../BackButton";
import ScrollToTop from "../ScrollToTop";
import { patreonUrl } from "../../constants";

const TermsOfUse = () => {
  return (
    <Page>
      <ScrollToTop />
      <div className="page-bar">
        <div className="inner">
          <div style={{ display: "flex", alignItems: "center" }}>
            <BackButton />
            <h4 className="bar-title">Угода користувача</h4>
          </div>
        </div>
      </div>
      <div className="page-offset">
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Загальні положення</strong>
        </h5>
        <p>
          1.1 Ця Угода регулює умови користування веб-застосунком{" "}
          <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>, доступним за
          адресою{" "}
          <a href={`https://${process.env.REACT_APP_DOMAIN}`}>
            https://{process.env.REACT_APP_DOMAIN}
          </a>{" "}
        </p>
        <p>
          1.2 Веб-застосунок{" "}
          <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong> розроблений для
          любителів футболу та шанувальників Першої Ліги.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Участь у грі</strong>
        </h5>
        <p>
          2.1 Участь дозволяється користувачам віком від 14 років. Особам віком
          від 14 до 18 років участь дозволяється лише за згодою батьків або
          законних представників.
        </p>
        <p>
          2.2 Ваші дані обробляються з метою реєстрації, участі у грі,
          статистики та комунікації.{" "}
        </p>
        <p>
          2.3 Ви погоджуєтесь, що ваші дані (ім’я, фото, ігрові результати)
          можуть бути публічно відображені на сервісі та в соціальних мережах.
        </p>
        <p>
          2.4 Доступ до ваших даних мають лише адміністратори сервісу. Дані
          можуть зберігатись на зовнішніх платформах, таких як AWS, Google. Ми
          не передаємо ваші дані третім особам без вашої згоди, окрім випадків,
          передбачених законом.
        </p>
        <p>
          2.5 Ви можете надіслати запит на видалення персональних даних, таких
          як ім’я або аватар (фото), відповідно до Закону України «Про захист
          персональних даних.» Для цього надішліть листа на{" "}
          <a
            href={`mailto:${process.env.REACT_APP_EMAIL}?subject="Видалення персональних даних"`}
          >
            електронну скриньку
          </a>{" "}
          з темою "Видалення персональних даних", в якому вкажіть ваше ім'я
          та/або ідентифікатор вашого користувача.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Інформація третіх сторін</strong>
        </h5>
        <p>
          3.1 Веб-застосунок може містити посилання на зовнішні ресурси, які не
          контролюються <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>.
          Ми не несемо відповідальності за політики конфіденційності або зміст
          таких ресурсів.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Доступ через Patreon</strong>
        </h5>
        <p>
          4.1 Після завершення періоду вільного доступу в 3 тижні, доступ до
          веб-застосунку <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>{" "}
          та його функцій надається лише користувачам із активною Patreon
          підпискою на{" "}
          <a href={patreonUrl}>
            <strong>канал ФЕНТЕЗІ ФУТБОЛ</strong>
          </a>
        </p>
        <p>
          4.2 Оплата підписки через Patreon не є ставкою, а здійснюється
          виключно для доступу до функцій та контенту веб-застосунку{" "}
          <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>.
        </p>
        <p>
          4.3 Оплата підписки та її розмір (таєр) не впливають на шанси
          користувачів на перемогу в турнірі
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Технічні аспекти</strong>
        </h5>
        <p>
          5.1 Сервіс надається «як є». Ми не гарантуємо безперервну роботу чи
          точність статистики.{" "}
        </p>{" "}
        <p>
          {" "}
          5.2 Ми не несемо відповідальності за технічні збої, втрату доступу чи
          даних{" "}
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Фентезі-футбол не є азартною грою</strong>
        </h5>
        <p>
          6.1 Фентезі-футбол не є азартною грою згідно із Законом України «Про
          державне регулювання діяльності щодо організації та проведення
          азартних ігор» #768-IX.
        </p>
        <p>
          6.2 У межах <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong> не
          проводяться грошові ставки, лотереї чи тоталізатори.
        </p>
        <p>
          6.3 <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong> є
          розважальним сервісом, де результат залежить від знань та вмінь
          учасників аналізувати події у футболі.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-check-lg"></i>&nbsp;
          <strong>Контакти</strong>
        </h5>
        <p>
          Для зв'язку з нами використовуйте{" "}
          <a href={process.env.REACT_APP_TELEGRAM_CHAT_LINK}>
            Telegram чат <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>
          </a>{" "}
          або адресу електронної пошти{" "}
          <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>
            {process.env.REACT_APP_EMAIL}
          </a>
        </p>
      </div>
    </Page>
  );
};

export default TermsOfUse;
